import React, { ComponentProps } from "react";

function WalletOpenIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="wallet 1" clipPath="url(#clip0_68_79747)">
        <path
          id="Vector"
          d="M15.5723 4.41782H2.12958C1.23866 4.41782 0.516449 3.69561 0.516449 2.80469V14.0966C0.516449 15.2845 1.47942 16.2475 2.66729 16.2475H15.5723C16.7602 16.2475 17.7232 15.2845 17.7232 14.0966V6.56866C17.7232 5.38072 16.7602 4.41782 15.5723 4.41782ZM14.4969 11.4081C13.903 11.4081 13.4215 10.9265 13.4215 10.3326C13.4215 9.73867 13.903 9.25721 14.4969 9.25721C15.0909 9.25721 15.5723 9.73867 15.5723 10.3326C15.5723 10.9265 15.0909 11.4081 14.4969 11.4081Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_68_79747">
          <rect
            width="17.2067"
            height="17.2067"
            fill="white"
            transform="translate(0.344574 0.114258)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default WalletOpenIcon;
